/**
 * @flow
 * @relayHash e6dd12c648c494f3e35f579060c9f5b0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedGLAccountsContainer_glAccounts$ref = any;
export type GLAccountSortField = "ACCOUNT_NUMBER" | "ACCOUNT_TYPE" | "CREATED_AT" | "NAME" | "UPDATED_AT";
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type SortDirection = "ASC" | "DESC";
export type GLAccountSort = {|
  field: GLAccountSortField,
  direction: SortDirection,
|};
export type PaginatedGLAccountsContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?GLAccountSort,
  accountTypes?: ?$ReadOnlyArray<GLAccountType>,
  isActive?: ?boolean,
|};
export type PaginatedGLAccountsContainerQueryResponse = {|
  +$fragmentRefs: PaginatedGLAccountsContainer_glAccounts$ref
|};
export type PaginatedGLAccountsContainerQuery = {|
  variables: PaginatedGLAccountsContainerQueryVariables,
  response: PaginatedGLAccountsContainerQueryResponse,
|};
*/


/*
query PaginatedGLAccountsContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: GLAccountSort
  $accountTypes: [GLAccountType!]
  $isActive: Boolean
) {
  ...PaginatedGLAccountsContainer_glAccounts_1odxbl
}

fragment PaginatedGLAccountsContainer_glAccounts_1odxbl on Query {
  glAccounts(first: $count, after: $cursor, search: $search, sortBy: $sortBy, accountTypes: $accountTypes, isActive: $isActive) {
    edges {
      cursor
      ...ChartOfAccountsTable_glAccountEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ChartOfAccountsTable_glAccountEdges on GLAccountEdge {
  node {
    id
    accountNumber
    name
    description
    accountType
    normalBalance
    balance
    isActive
    isSystem
    parentAccount {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "GLAccountSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountTypes",
    "type": "[GLAccountType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isActive",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "accountTypes",
  "variableName": "accountTypes"
},
v2 = {
  "kind": "Variable",
  "name": "isActive",
  "variableName": "isActive"
},
v3 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v4 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v5 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedGLAccountsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedGLAccountsContainer_glAccounts",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedGLAccountsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "glAccounts",
        "storageKey": null,
        "args": (v5/*: any*/),
        "concreteType": "GLAccountConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccountEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "GLAccount",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "normalBalance",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "balance",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isActive",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isSystem",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "parentAccount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "GLAccount",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "glAccounts",
        "args": (v5/*: any*/),
        "handle": "connection",
        "key": "PaginatedGLAccountsContainer_glAccounts",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedGLAccountsContainerQuery",
    "id": null,
    "text": "query PaginatedGLAccountsContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: GLAccountSort\n  $accountTypes: [GLAccountType!]\n  $isActive: Boolean\n) {\n  ...PaginatedGLAccountsContainer_glAccounts_1odxbl\n}\n\nfragment PaginatedGLAccountsContainer_glAccounts_1odxbl on Query {\n  glAccounts(first: $count, after: $cursor, search: $search, sortBy: $sortBy, accountTypes: $accountTypes, isActive: $isActive) {\n    edges {\n      cursor\n      ...ChartOfAccountsTable_glAccountEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChartOfAccountsTable_glAccountEdges on GLAccountEdge {\n  node {\n    id\n    accountNumber\n    name\n    description\n    accountType\n    normalBalance\n    balance\n    isActive\n    isSystem\n    parentAccount {\n      id\n      name\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1200d1d47f4f52dde0deae43c5f01e1';
module.exports = node;
